/// <reference path="../../js/_ResizeObserver.ts" />
import Component from '../../js/_Component';

export default class DecoratedBannerBox extends Component {
	private background: HTMLElement;

	private container: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		this.background = element.querySelector('.c-decorated-banner-box--background');
		this.container = element.querySelector('.c-decorated-banner-box--background-container');

		// Allow for a compact display mode.
		this.element.addEventListener('updatecompactmode', (e: CustomEvent) => {
			if (e.detail) {
				this.element.classList.add('m-compact');
			} else {
				this.element.classList.remove('m-compact');
			}
		});

		// Animate once half of the element is visible.
		const intersectionObserver = new IntersectionObserver((e) => {
			if (e[0].isIntersecting) {
				intersectionObserver.unobserve(element);
				element.classList.add('m-animate-in');
			}
		}, {threshold: 0.5});
		intersectionObserver.observe(element);

		// Update background element on resize.
		const resizeObserver = new ResizeObserver(() => this.updateSize());
		resizeObserver.observe(this.background);

		this.updateSize();
	}

	updateSize() {
		const rect = this.background.getBoundingClientRect();
		// Use the dot product of a unit normal and the container size to find the appropriate
		// inner box size.
		const angle = ((47 / 180) * Math.PI);
		const width = rect.width * Math.cos(angle) + rect.height * Math.sin(angle);
		const height = rect.width * Math.sin(angle) + rect.height * Math.cos(angle);
		this.container.style.width = `${width}px`;
		this.container.style.height = `${height}px`;
		// Modulate original width by angle, then subtract from new width to get the offset amount.
		const offset = width - Math.cos(angle) * rect.width;
		this.container.style.transform = `translate(-${offset}px , 0)`;
	}
}

Component.register(DecoratedBannerBox, 'DecoratedBannerBox');
